<template>
    <div>
        <vx-card class="">
        </vx-card>
    </div>
</template>

<script>

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
    data () {
        return {
            toolbar: '#toolbar',
            is_open:false,
            data:[],
            text:'',
            name:'',
            files:[],
            modal:false,
            let_files:null,
            disabled:false,
            editorOption:{
                placeholder:this.$t('enter_text'),
            }
        }
    },

    props: {
        item: {
            type: Object,
            required: true
        }
    },

    components: {
        quillEditor,
    },

    watch:{
        item(){
            this.modalUpdate();
        }
    },

    async created() {
        this.modalUpdate()
        // await console.log(this.item)
    },

    methods: {

    },
    computed: {
    }
}
</script>

<style lang="scss">
.bug_complete,
.take_to_work{
    position: relative;
    .con-vs-loading{
        position: absolute;
        background: transparent;
    }
}
</style>

<style lang="scss" scoped>
.file_bugs_item{
    &:not(:last-child){
        margin-bottom: 10px;
    }
    img{
        max-width: 100%;
        border: 1px solid #cccccc;
    }
}
</style>
